import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo_no_bg.png';

const Footer = () => {
  return (
    <footer className="bg-surface-container-lowest border-t border-outline-variant/30 w-full py-20 px-6 md:px-desktop relative overflow-hidden">
      <div className="max-w-container-max mx-auto grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-gutter">
        
        {/* Left: Brand Statement */}
        <div className="md:col-span-5 flex flex-col justify-between">
          <div>
            <div className="h-16 w-auto mb-8">
              <img 
                src={logo} 
                alt="HBB0011 REALTY Logo" 
                className="h-full w-auto object-contain brightness-0 invert opacity-80" 
              />
            </div>
            <h4 className="font-headline-lg text-[24px] md:text-[32px] text-on-surface font-light leading-snug mb-8 max-w-md">
              BUILDING ICONIC SPACES THAT STAND THE TEST OF TIME.
            </h4>
          </div>
          <div className="w-full h-px bg-gradient-to-r from-secondary to-transparent opacity-50 my-8"></div>
          <p className="font-label-caps text-[10px] text-on-surface-variant tracking-widest">
            © 2026 HBB0011 REALTY. ALL RIGHTS RESERVED.
          </p>
        </div>
        
        {/* Spacer for Layout */}
        <div className="hidden md:block md:col-span-1"></div>
        
        {/* Right: Core Values & Links */}
        <div className="md:col-span-6 flex flex-col">
          <h5 className="font-label-caps text-label-caps text-secondary tracking-[0.2em] mb-10">OUR CORE VALUES</h5>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-16">
            <div className="flex items-start gap-4">
              <span className="material-symbols-outlined text-outline-variant font-light mt-1">gpp_good</span>
              <div>
                <h6 className="font-label-caps text-[12px] text-on-surface mb-2">INTEGRITY</h6>
                <p className="font-body-md text-[13px] text-on-surface-variant">Unwavering commitment to honesty and transparency in every transaction.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="material-symbols-outlined text-outline-variant font-light mt-1">lightbulb</span>
              <div>
                <h6 className="font-label-caps text-[12px] text-on-surface mb-2">INNOVATION</h6>
                <p className="font-body-md text-[13px] text-on-surface-variant">Pioneering architectural solutions for modern living spaces.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="material-symbols-outlined text-outline-variant font-light mt-1">architecture</span>
              <div>
                <h6 className="font-label-caps text-[12px] text-on-surface mb-2">QUALITY</h6>
                <p className="font-body-md text-[13px] text-on-surface-variant">Meticulous attention to detail in every material and finish.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="material-symbols-outlined text-outline-variant font-light mt-1">eco</span>
              <div>
                <h6 className="font-label-caps text-[12px] text-on-surface mb-2">SUSTAINABILITY</h6>
                <p className="font-body-md text-[13px] text-on-surface-variant">Building with the future in mind, minimizing environmental impact.</p>
              </div>
            </div>
          </div>
          
          {/* Footer Links */}
          <div className="flex flex-wrap gap-6 mt-auto">
            <Link to="/privacy" className="font-label-caps text-[10px] text-on-surface-variant hover:text-primary transition-colors duration-300">PRIVACY POLICY</Link>
            <Link to="/terms" className="font-label-caps text-[10px] text-on-surface-variant hover:text-primary transition-colors duration-300">TERMS OF SERVICE</Link>
            <Link to="/disclaimer" className="font-label-caps text-[10px] text-on-surface-variant hover:text-primary transition-colors duration-300">DISCLAIMER</Link>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
